import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';

function Loader({ text, children }) {
  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: ' 50%',
      bgcolor: 'white',
      p: 2,
      border: 1,
      borderColor: 'primary.main',
      borderRadius: 2,
      boxShadow: 3,
      zIndex: 'tooltip',
    }}
    >
      <Box display="flex" alignItems="center">
        <CircularProgress id={text} />
        <Typography color="primary.main" sx={{ ml: 2 }}>
          {text}
        </Typography>
      </Box>
      {children}
    </Box>
  );
}

Loader.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
};

Loader.defaultProps = {
  text: 'Зачекайте будь-ласка...',
  children: null,
};

export default Loader;
